import { addProduct } from "../store/action"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { fetchItems, fetchCategories } from "../store/action";

import MainTableRow from "./MainTableRow";

import Swal from 'sweetalert2/dist/sweetalert2.js'

function MainTable() {
  const dispatch = useDispatch()
  const categories = useSelector((state) => state.categoryReducer.categories)
  const items = useSelector((state) => state.itemReducer.items)

  useEffect(() => {
    dispatch(fetchItems())
    dispatch(fetchCategories())
}, []);

  const [updateForm, setUpdateForm] = useState(
    {
      name: 'a',
      description: '',
      price: 0,
      mainImg: '',
      CategoryId: 0,
      images: []
    }
  )
  const [form, setForm] = useState([]);
  const [productForm, setProductForm] = useState(
    {
      name: '',
      description: '',
      price: 0,
      mainImg: '',
      CategoryId: 0,
      images: []
    }
  )

  const handleAddImage = (e) => {
    e.preventDefault();

    let newForm = form.map(f => {
      return f
    })

    newForm.push([])

    setForm(newForm)

    console.log(form)
  };

  const handleRemoveField = (e, i) => {
    e.preventDefault();
    let newForm = form.map(f => {
      return f
    })

    newForm.splice(i, 1)
    console.log(newForm)
    setForm(newForm)
  }

  const handleChange = (e) => {
    const { value, name } = e.target
    const input = {
      ...productForm,
      [name]: value
    }
    setProductForm(input)
  }

  const handleChangeImages = (e, index) => {

    let newForm = form.map(f => {
      return f
    })

    newForm[index] = e.target.value
    setForm(newForm)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    dispatch(addProduct(productForm))
    .then(resp => resp.json())
        .then(data => {
          Swal.fire(
            'New Product Added!',
            'Successfully added a new product to the database.',
            'success'
          )
          dispatch(fetchItems())
        })
        .catch(console.log)

    clearForm()

  }

  const clearForm = () => {
    setForm([])
    setProductForm({
      name: '',
      description: '',
      price: 0,
      mainImg: '',
      CategoryId: 0,
      images: []
    })
  }

  const handleUpdateButton = (e) => {
    let data = items.filter((p) => { return p.id == e.target.value })
    setUpdateForm(data)
  }

  useEffect(() => {
    setProductForm({
      ...productForm,
      images: form
    })
  }, [form]);

  return (
    <div className="px-3 py-5">
      <h1 className="mb-5">Product List</h1>

      <button className="btn btn-primary mb-5" type="button" data-toggle="modal" data-target="#formModal">
        + Add New Product
      </button>

      {/* <!-- Modal --> */}
      <div className="modal fade" id="formModal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Add Product</h5>
              <button type="button" className="close" data-dismiss="modal">
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">

              <div className="row mb-3">
                <div className="col-3">
                  <label>Name</label>
                </div>
                <div className="col">
                  <input type="text" className="form-control" onChange={handleChange} name="name" value={productForm.name} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-3">
                  <label>Description</label>
                </div>
                <div className="col">
                  <input type="text" className="form-control" onChange={handleChange} name="description" value={productForm.description} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-3">
                  <label>Price</label>
                </div>
                <div className="col">
                  <input type="number" className="form-control" onChange={handleChange} name="price" value={productForm.price} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-3">
                  <label>Image URL</label>
                </div>
                <div className="col">
                  <input type="text" className="form-control" onChange={handleChange} name="mainImg" value={productForm.mainImg} />
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-3">
                  <label>Category</label>
                </div>
                <div className="col">
                  <select defaultValue={"DEFAULT"} className="form-control" onChange={handleChange} name="CategoryId">
                    <option value="DEFAULT" disabled>Choose one...</option>
                    {categories.map(c => {
                      return (<option key={c.id} value={c.id}>{c.name}</option>)
                    })}
                  </select>
                </div>
              </div>
              {form.map((f, index) => {
                return (
                  <div className="row mb-3" key={index}>
                    <div className="col-3">
                      <label>Images</label>
                    </div>
                    <div className="col">
                      <input type="text" value={f} className="form-control" onChange={(e) => handleChangeImages(e, index)} />
                    </div>
                    <button className="btn btn-danger" onClick={(e) => handleRemoveField(e, index)} >&times;</button>
                  </div>
                )
              })}

              <button className="btn btn-outline-primary" onClick={handleAddImage}>Add More Image</button>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={clearForm}>Close</button>
                <button type="submit" className="btn btn-primary" onClick={handleSubmit}>Submit</button>
              </div>

            </div>
          </div>
        </div>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th scope="col">No</th>
            <th scope="col">Name</th>
            <th scope="col">Category</th>
            <th scope="col">Price</th>
            <th scope="col">Created By</th>
            <th scope="col">Main Image</th>
            <th scope="col">Images</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
             <MainTableRow item={item} index={index} key={index} />
            );
          })}
        </tbody>
      </table>
    </div>
  )
}

export default MainTable